import { Button, DivTooltip, Menu, TooltipBody, ButtonIcon } from "@wg/wows-react-uikit";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  SetBackgroundUrl,
  SetBuildingLevel,
  showEdges,
  hideEdges,
} from "../../Actions/ActionSupply";
import styles from "./DevMenu.scss";

export type IProps = {
  buildings: any;
  backgroundUrl: string;

  SetBuildingLevel: (buildingId: string, level: number) => void;
  SetBackgroundUrl: (backgroundUrl: string) => void;
  showEdges: () => void,
  hideEdges: () => void,
};

export type IState = {
  isOpened: boolean;
};

class DevMenu extends Component<IProps, IState> {


  state = {
    isOpened: false
  };

  selectedBgVersion: string | null = null;

  renderItems = () => {
    const items = [];

    for (const key in this.props.buildings) {
      if (this.props.buildings.hasOwnProperty(key)) {
        const item = this.props.buildings[key];
        const edgesVisible = this.props.edgesVisible[key]
        items.push(<li className={styles.devPanelItem}>
          <div className={styles.devPanelButton}>
            <Button isDisabled={item.level == 0} onClick={() => {

              let newLevel = item.level - 1;

              if (newLevel < 0) {
                newLevel = 0;
              }

              this.props.SetBuildingLevel(key, newLevel);
            }}>{'-'}</Button>
          </div>
          <span className={styles.devPanelItemName}>{`${item.name} - ${item.level}`}</span>
          <div className={styles.devPanelButton}>
            <Button isDisabled={item.level == item.maxLevel} onClick={() => {

              let newLevel = item.level + 1;

              if (newLevel > item.maxLevel) {
                newLevel = item.maxLevel;
              }

              this.props.SetBuildingLevel(key, newLevel);
            }}>{'+'}</Button>
          </div>
          <div className={styles.devPanelButton}>
            {edgesVisible ? (
              <Button onClick={() => { this.props.hideEdges(key) }}>
                {'✕'}
              </Button>
            ) : (
                <Button onClick={() => { this.props.showEdges(key) }}>
                  {'✓'}
                </Button>
              )}
          </div>
        </li>);

      }
    }

    return items;
  };

  onUrlSelect = val => {

    const oldVersion = this.selectedBgVersion ? this.selectedBgVersion : 'noversion';
    const newVersion = `${val}`;

    const newBgUrl = this.props.backgroundUrl.replace(oldVersion, newVersion);
    this.props.SetBackgroundUrl(newBgUrl);
  };

  renderMenu = () => {

    const items = [{
      value: '0.8.3',
      content: <span>{'0.8.3'}</span>
    }, {
      value: '0.8.0',
      content: <span>{'0.8.0'}</span>
    }, {
      value: '0.7.9',
      content: <span>{'0.7.9'}</span>
    }];

    let selectedIndex = 0;

    items.forEach((item, index) => {
      if (this.props.backgroundUrl.indexOf(item.value) !== -1) {
        selectedIndex = index;
      }
    });

    this.selectedBgVersion = items[selectedIndex].value;

    return <Menu items={items} itemSelected={selectedIndex} onItemChange={this.onUrlSelect}>
      <span>{`${items[selectedIndex].value}`}</span>
    </Menu>;
  };

  openPanel = () => {
    this.setState({
      isOpened: true
    });
  };

  closePanel = () => {
    this.setState({
      isOpened: false
    });
  };

  render() {
    if (this.state.isOpened) {
      return (

        <div className={styles.devPanel}>
          <div className={styles.backgroundMenu}>
            <span className={styles.titleMenu}>{'Версия топоосновы'}</span>
            {this.renderMenu()}
          </div>
          <ul>
            {this.renderItems()}
          </ul>
          <div className={styles.closeButtonRow}>
            <ButtonIcon
              onClick={this.closePanel}
              tooltipContent={(
                <TooltipBody>
                  {'Скрыть панель'}
                </TooltipBody>
              )}
              type="info"
            />
          </div>

        </div>
      )
    } else {
      return (
        <div className={styles.openButton}>
          <ButtonIcon
            onClick={this.openPanel}
            tooltipContent={(
              <TooltipBody>
                {'Показать панель'}
              </TooltipBody>
            )}
            type="info"
          />
        </div>
      )
    }

  }
}

const mapStateToProps = (state) => ({
  buildings: state.ReducerSupply.buildings,
  backgroundUrl: state.ReducerSupply.backgroundUrl,
  edgesVisible: state.ReducerSupply.edgesVisible
})

const mapDispatchToProps = (dispatch) => {
  return {
    SetBuildingLevel: (buildingId: string, level: number) => {
      dispatch(SetBuildingLevel(buildingId, level))
    },
    SetBackgroundUrl: (backgroundUrl: string) => {
      dispatch(SetBackgroundUrl(backgroundUrl))
    },
    showEdges: (buildingId) => {
      dispatch(showEdges(buildingId))
    },
    hideEdges: (buildingId) => {
      dispatch(hideEdges(buildingId))
    },
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(DevMenu);